import axios from 'axios';
import { requestInterceptor, responseInterceptor, errorInterceptor } from './interceptors';
import {localapiurl} from '../constant';

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: `${localapiurl}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Apply interceptors
axiosInstance.interceptors.request.use(requestInterceptor, (error) => Promise.reject(error));
axiosInstance.interceptors.response.use(responseInterceptor, errorInterceptor);

export default axiosInstance;